/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthSendPasswordUpdatedEmail200Response
 */
export interface AuthSendPasswordUpdatedEmail200Response {
    /**
     * 
     * @type {boolean}
     * @memberof AuthSendPasswordUpdatedEmail200Response
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthSendPasswordUpdatedEmail200Response
     */
    message?: string;
}

/**
 * Check if a given object implements the AuthSendPasswordUpdatedEmail200Response interface.
 */
export function instanceOfAuthSendPasswordUpdatedEmail200Response(value: object): value is AuthSendPasswordUpdatedEmail200Response {
    return true;
}

export function AuthSendPasswordUpdatedEmail200ResponseFromJSON(json: any): AuthSendPasswordUpdatedEmail200Response {
    return AuthSendPasswordUpdatedEmail200ResponseFromJSONTyped(json, false);
}

export function AuthSendPasswordUpdatedEmail200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthSendPasswordUpdatedEmail200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function AuthSendPasswordUpdatedEmail200ResponseToJSON(json: any): AuthSendPasswordUpdatedEmail200Response {
    return AuthSendPasswordUpdatedEmail200ResponseToJSONTyped(json, false);
}

export function AuthSendPasswordUpdatedEmail200ResponseToJSONTyped(value?: AuthSendPasswordUpdatedEmail200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

